module.exports = __webpack_public_path__ + "img/about-intro-pic.ad3d67d6.png";